import { StateNode } from '@ansys-internal/awf-angular/store';

export class ArchitectureMaxSpeedState implements StateNode<number | null> {
  key: string = 'max_speed';
  // mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => number | null = () => 0;
}
